import React from "react";

const HeaderBanner = (title, background) => {
    const backgroundImage = (background !== "" )? `/images/${background}` : "/images/dog-and-cat-blue.jpg";
    // console.log(title, backgroundImage);
    return (
        <div className="conatiner-fluid header-banner" style={{background: `url(${backgroundImage}) no-repeat center center`}}>
            <div className="row">
                <div className="title col-sm-12">
                    {title !== "" && (
                        <div className="container">
                            <div className="row">
                                <div className="col-sm-12">
                                <h1>{title}</h1>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default HeaderBanner;